"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var engine_1 = require("./engine");
var schema_1 = require("./schema");
var schemas_1 = require("./schemas");
exports.default = {
    translate: engine_1.translate,
    Schema: schema_1.Schema,
    Schemas: schemas_1.Schemas,
    ALA_LC: schemas_1.Schemas.get("ala_lc"),
    ALA_LC_ALT: schemas_1.Schemas.get("ala_lc_alt"),
    BGN_PCGN: schemas_1.Schemas.get("bgn_pcgn"),
    BGN_PCGN_ALT: schemas_1.Schemas.get("bgn_pcgn_alt"),
    BS_2979: schemas_1.Schemas.get("bs_2979"),
    BS_2979_ALT: schemas_1.Schemas.get("bs_2979_alt"),
    GOST_16876: schemas_1.Schemas.get("gost_16876"),
    GOST_16876_ALT: schemas_1.Schemas.get("gost_16876_alt"),
    GOST_52290: schemas_1.Schemas.get("gost_52290"),
    GOST_52535: schemas_1.Schemas.get("gost_52535"),
    GOST_7034: schemas_1.Schemas.get("gost_7034"),
    GOST_779: schemas_1.Schemas.get("gost_779"),
    GOST_779_ALT: schemas_1.Schemas.get("gost_779_alt"),
    ICAO_DOC_9303: schemas_1.Schemas.get("icao_doc_9303"),
    ISO_9_1954: schemas_1.Schemas.get("iso_9_1954"),
    ISO_9_1968: schemas_1.Schemas.get("iso_9_1968"),
    ISO_9_1968_ALT: schemas_1.Schemas.get("iso_9_1968_alt"),
    MOSMETRO: schemas_1.Schemas.get("mosmetro"),
    MVD_310: schemas_1.Schemas.get("mvd_310"),
    MVD_310_FR: schemas_1.Schemas.get("mvd_310_fr"),
    MVD_782: schemas_1.Schemas.get("mvd_782"),
    SCIENTIFIC: schemas_1.Schemas.get("scientific"),
    TELEGRAM: schemas_1.Schemas.get("telegram"),
    UNGEGN_1987: schemas_1.Schemas.get("ungegn_1987"),
    WIKIPEDIA: schemas_1.Schemas.get("wikipedia"),
    YANDEX_MAPS: schemas_1.Schemas.get("yandex_maps"),
    YANDEX_MONEY: schemas_1.Schemas.get("yandex_money"),
};
